import React from 'react';
import { Fade } from '../../animation/animation';
import styles from './footer.module.scss';
import cn from 'classnames';
import { StateType } from '../../reducers/history/enums/state-type.enum';

interface FooterProps {
	license?: string
	currentState: StateType
}

export default function Footer({license, currentState, children}:React.PropsWithChildren<FooterProps>) {
	return (
		<Fade delay={400} when={currentState != StateType.FORM}>
			<div className={styles.footer}>
				{children}

				<div className={cn(
					license ? styles.license : styles.default, 
					{[styles.fadeOut]: currentState != StateType.INITIAL && currentState != StateType.RESULT } 
				)}>
					<p>Имеются противопоказания, необходима консультация 
					специалиста. Предложение не является публичной офертой</p>
					{ license && <p>{license}</p>}
				</div>
			</div>
		</Fade>
	);
}	